import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';

function Form({ defaultValues, onSubmit, onStateChange, children, }) {
    const methods = useForm({
        mode: "onTouched",
        defaultValues,
    });
    const { formState: { isValid, isDirty }, } = methods;
    useEffect(() => {
        onStateChange === null || onStateChange === void 0 ? void 0 : onStateChange({ isValid, isDirty });
    }, [isValid, isDirty, onStateChange]);
    return (jsx(FormProvider, Object.assign({}, methods, { children: jsx("form", { onSubmit: methods.handleSubmit(onSubmit), children: children }) })));
}

export { Form };
//# sourceMappingURL=Form.js.map
